import { IncomeReportContent } from "../../components/report/income"


export const IncomeReport = () => {

    return(
        <>
            <IncomeReportContent />
        </>
    )

}